module.exports = __webpack_public_path__ + "img/group1.44857851.svg";